var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#009E49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938L539.79 170.994L0 341.994V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.8712L495.9 170.994L0 327.117V14.8712Z",
    fill: "#FFD00D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938L256.5 170.994L0 341.994V-0.00585938Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9442L226.575 170.994L0 322.044V19.9442Z",
    fill: "#D3132F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/GY.b123b4d634268bb4f4cd4749d7a327e9.svg";
export { ForwardRef as ReactComponent };